// extracted by mini-css-extract-plugin
export default {"container":"MapUIOverlay_container__-pxWA","canvasOverlay":"MapUIOverlay_canvasOverlay__Oxjzy","highlightedObjectRect":"MapUIOverlay_highlightedObjectRect__H1yBO"};